import type { ComparisonCreditCardOffer } from '../types';

export const sortOffersAlphabetically = (offers: ComparisonCreditCardOffer[]) =>
  offers.sort((offer1, offer2) => offer1.name.localeCompare(offer2.name));
